/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExclamationInTriangleStatusIcon = createIcon("ExclamationInTriangleStatusIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.35 13.261 9.17 1.518a1.323 1.323 0 00-2.342 0L.651 13.26c-.215.408-.2.898.04 1.292.24.394.668.634 1.131.634h12.356c.462 0 .891-.24 1.131-.634a1.31 1.31 0 00.04-1.292ZM7.34 5.645A.66.66 0 018 4.987a.66.66 0 01.66.658v3.947a.66.66 0 01-.66.658.66.66 0 01-.66-.658V5.645Zm.693 7.572h-.018a1.008 1.008 0 01-1.006-.967.968.968 0 01.266-.703.977.977 0 01.69-.304h.02c.54.001.985.427 1.006.966a.974.974 0 01-.958 1.008Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});